import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
import { ThreeDots } from "react-loader-spinner";
const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 999999,
    color: "#fff",
  },
  circularProgress: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    color: theme.colors.DodgerBlue,
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // zIndex: 10,
    zIndex: 999999,
    // pointerEvents: "none",
    background: "rgba(255, 255, 255, 0.4)",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
  }
}
));

function Loading({ showLoader }) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={showLoader}>
      <CircularProgress
        className={classes.circularProgress}
        thickness={2}
        size={100}
      />
    </Backdrop>
  );
}

export function ThreeDotsLoading({ showLoader }) {
  const classes = useStyles();

  return <Backdrop className={classes.loaderContainer} open={showLoader}>
    <ThreeDots color="#3E83FB" />
  </Backdrop>
}

export default Loading;
